import { AppThunk } from '../../../../store/types';
import { setActiveGroupId } from '../../../../store/models/actions';
import { getActiveGroupId, getAudioById } from '../../../../store/models/selectors';
import { RecordingsEffects } from '../../../../effects/recordingsEffects';
import { TConferenceProcessSteps } from '../../../../../common/rest/conference/conferenceRest';
import { changeCurrentAudioId } from '../../../../store/current-video/actions';
import { getCurrentAudioId } from '../../../../store/current-video/selectors';
import { Navigator } from '../../../../effects/navigator';
import { EAudioPageTab } from '../components/types';
import { getTargetCaptions } from '../../../../store/videos/selectors';
import { PlayerController } from '../../../../effects/player/manager/playerController';
import { findCaptionIndexAt } from '../LessonTranscript/components/types';
import { getLessonPlayback } from '../../selectors/getLessonPlayback';

export class AudioPageEvents {

  public static onChangeRoute(groupId: number, audioId: number): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      if (groupId && getActiveGroupId(getState()) !== groupId) {
        dispatch(setActiveGroupId(groupId));
      }
      if (audioId && getCurrentAudioId(getState()) !== audioId) {
        dispatch(changeCurrentAudioId(audioId));
      }
    }
  }

  public static onChangeTab(groupId: number, audioId: number, tab: EAudioPageTab): AppThunk {
    return () => {
      Navigator.setAudioTab(groupId, audioId, tab);
    }
  }

  public static onReprocess(force?: boolean, steps?: TConferenceProcessSteps): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const audioId = getCurrentAudioId(getState());
      if (!audioId) return;
      const audio = getAudioById(getState(), audioId);
      return RecordingsEffects.reprocessConference(RecordingsEffects.getRoomIdForAudio(audio), audioId, force, steps);
    }
  }

  public static onCancel(): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const audioId = getCurrentAudioId(getState());
      if (!audioId) return;
      const audio = getAudioById(getState(), audioId);
      return RecordingsEffects.cancelConference(RecordingsEffects.getRoomIdForAudio(audio), audioId);
    }
  }

  public static onCloseSettings(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      const audioId = getCurrentAudioId(getState());
      if (audioId) RecordingsEffects.flushConferenceSettings(audioId);
    }
  }

  // exercise/word timestamp: the same line LessonTranscript highlights for that time
  public static onPlayTimestamp(time: number): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      dispatch(AudioPageEvents.onPlayCaption(findCaptionIndexAt(getTargetCaptions(getState()), time)));
    }
  }

  // mobile: closing the transcript sheet hides the only playback feedback, so stop it
  public static onPause(): AppThunk {
    return () => {
      PlayerController.getInstance().pause();
    }
  }

  public static onPlayCaption(index: number): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      const captions = getTargetCaptions(getState());
      const caption = captions[index];
      if (!caption) return; // a timestamp before the first line
      // media deleted (saveLevel transcription): there's no player, startPlay would wait forever
      if (getLessonPlayback(getState()) === 'none') return;
      const playerController = PlayerController.getInstance();
      // a second click on the phrase that is playing stops it
      if (playerController.isPlayingOnce(caption)) {
        playerController.pause();
      } else {
        playerController.playCaptionOnce(caption, captions[index + 1]);
      }
    }
  }

}
